// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkoutPlayer_root__DTAJC"};